// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://jdtikr3wa5fpjdep6yy7un5m3e.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-vavlrvurrfhjrj7ui3no3mi6py",
    "aws_cognito_identity_pool_id": "us-east-2:d9394551-5f56-43d5-8a9f-b77c9abf0ce9",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_xmntlwsU9",
    "aws_user_pools_web_client_id": "65bm6pl9a63bnqfpek25j5622b",
    "oauth": {},
    "aws_content_delivery_bucket": "blog-app-20200421141722-hostingbucket-blogapi",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "http://blog-app-20200421141722-hostingbucket-blogapi.s3-website.us-east-2.amazonaws.com"
};


export default awsmobile;
